"use client";
import React from "react";
import { Button, Grid } from "semantic-ui-react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { GoogleMapExample } from "../../pagecomponents/PresentationalComponent/GoogleMapWrapperCity";
import axios from "axios";
import { getcitydata } from "../../modules/Graphql/cityquestionandanswergraphql";
import {
  getOrdinalSuffix,
  get_npi_color,
  get_nvi_color,
  get_price_color,
  get_appreciation_color,
  get_all_amenties_color,
  get_school_color,
  separateCityAndState,
  getCitiesForRegion,
} from "../../common/Utils";

import { Amplify, Auth } from "aws-amplify";
import CognitoConfig from "../../common/Cognitoconfig";

// Amplify.configure(CognitoConfig);
let mapOptions = {
  styles: [
    {
      featureType: "administrative",
      stylers: [{ saturation: -35 }, { lightness: 25 }],
    },
    {
      featureType: "landscape",
      stylers: [{ color: "#e3ddda" }, { visibility: "on" }],
    },
    { featureType: "poi", stylers: [{ saturation: -30 }, { lightness: 35 }] },
    {
      featureType: "poi.attraction",
      stylers: [{ saturation: -55 }, { lightness: 5 }],
    },
    { featureType: "poi.business", stylers: [{ saturation: -60 }] },
    {
      featureType: "poi.government",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.medical",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#b3dfbe" }],
    },
    { featureType: "road", stylers: [{ saturation: -55 }, { lightness: 40 }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#bccae1" }],
    },
  ],
  zoomControlOptions: {
    style: "SMALL",
  },
  mapTypeControlOptions: {
    style: "TINY",
  },
  streetViewControl: false,
  disableDoubleClickZoom: true,
  gestureHandling: "greedy",
  fullscreenControl: true,
};
class Rankingmap extends React.Component {
  centerPt;

  constructor(props) {
    super(props);
    this.map = null;
    this.city_name_map;
    this.state_name_map;
    this.polygon_points = [];
    this.pbermudaTriangle = [];
    this.home_points = [];
    this.citybermudaTrianglesingle = [];
    this.npiscore = [];
    this.homegmarkers = [];
    this.arr = [];
    this.loadrcount = 0;
    this.state = {
      singlehome: [],
      the_message: "",
      fetchschool: [],
      fetchneighbor: [],
      mapsData: [],
      shelters: [],
      markers: [],
      selectedMarker: null,
      polyGon: [],
      boolWindow: null,
      schoolImage: false,
      selectedtab: "school",
      singleneighbor: [],
      tabselect: 0,
      getfilterdata: [],
      userdetails: "",
      loggedin: false,
      zooms: 11,
      selectedNeighborhood: "",
      lat: "",
      lng: "",
      rhpmapcords: [],
      loaderdispaly: "none",
    };
  }

  onZoomChanged = () => {
    // this.bound_changed();
  };
  clearNhmarkers = () => {
    if (this.homegmarkers.length > 0) {
      for (var i = 0; i < this.homegmarkers.length; i++) {
        this.homegmarkers[i].setMap(null);
      }
    }
    this.homegmarkers = [];
    this.home_points = [];
  };
  bound_changed = () => {
    // let zoom_level = this.map.state.map.getZoom();

    let cdata = [];
    this.npiscore = [];
    let cityname = this.city_name_map ? this.city_name_map : "";
    const getcounties = getCitiesForRegion(cityname);
    let filterBy = "postalcity_name";
    let operateBy = "=";
    let filtervalue = cityname;
    if (getcounties !== "") {
      filterBy = "postalcity_name";
      operateBy = "IN";
      filtervalue = getcounties;
    }
    this.clearNhmarkers();
    // if(zoom_level < 13){

    for (var i = 0; i < this.pbermudaTriangle.length; i++) {
      this.pbermudaTriangle[i].setMap(null);
    }
    this.polygon_points = [];
    // }
    this.setState({ loaderdispaly: "none" });
    // if (zoom_level >= 12) {
    if (this.loadrcount === 0) {
      this.setState({ loaderdispaly: "block" });
    }
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "citymap",
      fields: [
        {
          name: filterBy,
          value: filtervalue,
          operator: operateBy,
        },
      ],
    };
    getcitydata(getdata)
      .then((result) => {
        if (result.data.getcitydata.length > 0) {
          this.loadrcount = this.loadrcount + 1;
          this.setState({ loaderdispaly: "none" });

          // Create InfoWindow once
          if (!this.infoWindow) {
            this.infoWindow = new google.maps.InfoWindow();
          }

          result.data.getcitydata.map((item, index) => {
            const selectedfilter = this.props.selectedfilter;

            // Push score based on selected filter
            switch (selectedfilter) {
              case "Overall Score":
                this.npiscore.push(item.npi || 0);
                break;
              case "School Score":
                this.npiscore.push(item.school || 0);
                break;
              case "Safety Score":
                this.npiscore.push(item.crime || 0);
                break;
              case "Amenities Score":
                this.npiscore.push(
                  item.amenities > 0 ? item.amenities : (item.walkability || 0) / 2,
                );
                break;
              case "Lowest Price":
                this.npiscore.push(item.medianprice || 0);
                break;
              case "Most Undervalued":
                this.npiscore.push(item.value || 0);
                break;
              case "Best Appreciation":
                this.npiscore.push(item.appreciation || 0);
                break;
              default:
                break;
            }

            if (item.geometry_cords) {
              const cdata = item.geometry_cords;

              cdata.forEach((polygonStr, index3) => {
                if (!this.polygon_points.includes(polygonStr)) {
                  this.polygon_points.push(polygonStr);

                  const coords = JSON.parse(polygonStr).map((coord) => ({
                    lat: parseFloat(coord.x),
                    lng: parseFloat(coord.y),
                  }));

                  const polygon = new google.maps.Polygon({
                    paths: [coords],
                    strokeColor: "#FFFFFF",
                    strokeWeight: 1,
                    zIndex: 2,
                    id: item.id,
                    nhfullname: item.nhfullname,
                  });

                  // Set fill color based on filter
                  const score = this.npiscore[index];
                  let fillColor = "#F9FADF";
                  let fillOpacity = 0;

                  switch (selectedfilter) {
                    case "Overall Score":
                      fillColor = get_npi_color(Math.round(score));
                      fillOpacity = 0.75;
                      break;
                    case "School Score":
                    case "Safety Score":
                      fillColor = get_school_color(score);
                      fillOpacity = fillColor === "#F9FADF" ? 0.0 : 0.75;
                      break;
                    case "Amenities Score":
                      fillColor = get_all_amenties_color(score);
                      fillOpacity = fillColor === "#F9FADF" ? 0.0 : 0.75;
                      break;
                    case "Lowest Price":
                      fillColor = get_price_color(Math.round(score));
                      fillOpacity = fillColor === "#F9FADF" ? 0.0 : 0.75;
                      break;
                    case "Most Undervalued":
                      fillColor = get_nvi_color(score);
                      fillOpacity = fillColor === "#F9FADF" ? 0.0 : 0.75;
                      break;
                    case "Best Appreciation":
                      fillColor = get_appreciation_color(score);
                      fillOpacity = fillColor === "#F9FADF" ? 0.0 : 0.75;
                      break;
                  }

                  polygon.setOptions({ fillColor, fillOpacity });

                  // === Polygon Events ===
                  google.maps.event.addListener(polygon, "click", function () {
                    window.open(`/Neighborhood/${this.nhfullname}`, "_blank");
                  });

                  google.maps.event.addListener(
                    polygon,
                    "mouseover",
                    (event) => {
                      polygon.setOptions({
                        strokeWeight: 3.6,
                        opacity: 0,
                        zIndex: 3,
                        strokeColor: "#db2828",
                      });

                      this.infoWindow.setContent(
                        `<div style="font-weight:bold">${polygon.nhfullname}</div>`,
                      );
                      this.infoWindow.setPosition(event.latLng);
                      this.infoWindow.open(this.map.state.map);
                    },
                  );

                  google.maps.event.addListener(polygon, "mouseout", () => {
                    polygon.setOptions({
                      strokeWeight: 1,
                      opacity: 0,
                      zIndex: 2,
                      strokeColor: "#FFFFFF",
                    });
                    this.infoWindow.close();
                  });

                  polygon.setMap(this.map.state.map);
                  this.pbermudaTriangle.push(polygon);
                }
              });
            }

            this.addMarkers(this.props.nhmarkerdata); // if needed per item
          });
        }
      })
      .catch((error) => {
        console.log("error-->", error);
      });
    // }
  };

  findIndex = (data) => {
    const dataArray = this.props.itemData;
    const searchId = data.id;

    const index = dataArray.findIndex((obj) => obj.id === data.id);

    if (index !== -1) {
      const currentIndex = index + 1;
      const indexData = getOrdinalSuffix(currentIndex);
      return currentIndex + indexData;
    }
  };

  addMarkers(markersdata) {
    this.clearNhmarkers();
    let icons = {
      url: "/static/images/redcircel.png",
      scaledSize: new google.maps.Size(35, 35),
      strokeColor: "#FFFFFF",
      origin: new google.maps.Point(0, 0),
      // anchor: new google.maps.Point(35, 25),
      // labelOrigin: new google.maps.Point(18, 8),
      //fontSize: "8px"
    };

    if (markersdata && markersdata.length > 0) {
      markersdata.map((item2, index2) => {
        const markerText = this.findIndex(item2);
        if (!this.home_points.includes(item2.latitude + item2.longitude)) {
          this.home_points.push(item2.latitude + item2.longitude);
          let newloc = {
            lat: parseFloat(item2.latitude),
            lng: parseFloat(item2.longitude),
          };
          var marker = new google.maps.Marker({
            position: newloc,
            label: {
              text: markerText,
              color: "#fff",
              fontSize: "12px",
            },
            icon: icons,
            //animation: google.maps.Animation.DROP,
            id: item2.id,
            nhfullname: item2.nhfullname,
          });

          google.maps.event.addListener(marker, "click", function (event) {
            window.open(`/Neighborhood/${this.nhfullname}`, "_blank");
            //Router.push('/DetailsNh');
          });
          if (this.map && this.map != null) {
            marker.setMap(this.map.state.map);
            this.homegmarkers.push(marker);
          }
        }
      });
    }
  }

  componentDidMount() {
    const slug = window.location.href;
    const parts = slug.split("/");
    const pageurl = parts[parts.length - 2];
    // const searchParams = new URLSearchParams(window.location.search);
    const { city_name, state_name } = separateCityAndState(pageurl);
    this.city_name_map = city_name;
    this.state_name_map = state_name;
    this.getplolygon(this.city_name_map, this.state_name_map);
    // const script = document.createElement("script");
    // script.src =
    //   "https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js";
    // script.async = true;
    // document.body.appendChild(script);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedfilter !== prevProps.selectedfilter) {
      // The selected filter has changed, perform action after 2 seconds
      setTimeout(() => {
        this.bound_changed();
      }, 2000);
    }

    if (this.props.nhmarkerdata !== prevProps.nhmarkerdata) {
      // nhmarkerdata has changed, call addMarkers
      setTimeout(() => {
        this.addMarkers(this.props.nhmarkerdata);
      }, 1000);
    }
  }

  getplolygon = (citydata, statedata) => {
    var geocoder = new google.maps.Geocoder();
    let final_cords = [];
    let that = this;
    var city_name = citydata + " , " + statedata;

    if (geocoder) {
      geocodeByAddress(city_name)
        .then((results) => getLatLng(results[0]))
        .then((latLng) => {
          geocoder.geocode({ address: city_name }, function (results, status) {
            let searchaddress = city_name
              ? city_name.replace(/,[^,]+$/, "%")
              : "";
            if (results) {
              var citydata = [];
              axios
                .get(
                  `https://nominatim.openstreetmap.org/search.php?q=${city_name}&polygon_geojson=1&format=geojson`,
                )
                .then((res) => {
                  if (res.data && res.data.features.length > 0) {
                    var result = res.data.features.filter(
                      (number) =>
                        number.geometry.type === "Polygon" ||
                        number.geometry.type === "MultiPolygon",
                    );
                    result = result[0];

                    var city_info = res.data;
                    that.setState({
                      lat: latLng.lat,
                    });
                    that.setState({
                      lng: latLng.lng,
                    });

                    setTimeout(() => {
                      that.bound_changed();
                    }, 2000);
                  }
                });
            }
          });
        });
    }
  };

  render() {
    return (
      <div>
        {this.state.lat !== "" && (
          <Grid>
            <Grid.Row>
              <Grid.Column id="map" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                  <GoogleMapExample
                    options={mapOptions}
                    ref={(c) => {
                      this.map = c;
                    }}
                    defaultCenter={{ lat: this.props.lat, lng: this.props.lng }}
                    zoom={11}
                    data={this}
                    // onClick={this.handleClick}
                    // onDragEnd={this.onDragChanged}
                    onZoomChanged={this.onZoomChanged}
                    mapContainerStyle={{
                      height: "300px",
                      width: "100%",
                    }}
                    mapElement={<div style={{ height: "100%" }} />}
                  />
                  <div
                    id="loadingDivcity"
                    className="loading"
                    style={{ display: this.state.loaderdispaly }}
                  >
                    Loading Data...
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
      </div>
    );
  }
}

export default Rankingmap;
